module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAYAAABWk2cPAAABbklEQVR42sWXQWrCQBSGvYCnKDmGe20PID2APYAUg3Zl1/YIdhGwW7sLptkFBAsW7EqFNITgwq6DGEj4OzOGlJCF8xIZP/gXSUg+JnkveanJAEBj0VlMFp8lxok43TbT41qtKgAaLDZo2Py8MrI6i4FqGCx1WeENywaXYcOvJyPc4bLscuLCLaWskL7i4q2mPsMf18XnYoHv1QpBECBJEpzBKFapJFEUYdDv47bZzGW73eIcuaqmtMX7dFoQ3rVaOB6PkMD+b3wCL6NRJnsaDPC1XMJxHBDQuFQHgefhMJNasxlKoHOpCQkOhwNc14Xe62XSt8lE7PM8DwRMLvUhAavSVFbMfbsNAj6XxlWlD50OCMQ1SBKGoRA/druZ7HU85vtEu1AQKy1bSB+WhRTySn3FUl9Ur2KpKfpUsVT0qaZYqmXvXkVSO/eVUSRtlPqertdrzOdzkd/9HgSMa04O6mck9dOg+rn3+hO++n+ZP3nUSaGje69cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fb.png
// module id = Y3Bk
// module chunks = 15